"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _typeof2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/typeof.js"));
var _toConsumableArray2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
var _objectSpread2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _mixins = _interopRequireDefault(require("./mixins"));
var _default = exports.default = {
  name: 'wl-form-control',
  mixins: _mixins.default,
  data: function data() {
    return {
      control: [],
      parentGrid: {}
    };
  },
  /* 计算属性 */
  computed: {},
  methods: {
    init: function init() {
      var _this = this;
      this.getParentConfig();
      this.$nextTick(function () {
        _this.getParentConfig();
        _this.onScroll();
      });
      this.setFormControl();
    },
    /** 获取 基础设置
     * @description: 获取 基础设置
     * @return { void }
     */
    getParentConfig: function getParentConfig() {
      var _this2 = this;
      var _a = function a($parent) {
        if ($parent && typeof ($parent === null || $parent === void 0 ? void 0 : $parent.getConfig) === 'function') {
          var _$parent$getConfig = $parent.getConfig(),
            grid = _$parent$getConfig.grid,
            rules = _$parent$getConfig.rules,
            form = _$parent$getConfig.form;
          if (!grid && !rules && !form) _a($parent.$parent);else {
            if (_this2.$$isNoEmpty(grid)) Object.assign(_this2.parentGrid, grid);
            if (_this2.$$isNoEmpty(form)) Object.assign(_this2.form, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, form), _this2.form));
            if (_this2.$$isNoEmpty(rules)) Object.assign(_this2.rules, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, rules), _this2.rules));
          }
        } else if ($parent.$parent) _a($parent.$parent);
      };
      _a(this.$parent);
    },
    /**
     * @description: 获取 查询条件
     * @param { Array | String } field 获取单个或者一组
     * @return { void }
     */
    getValue: function getValue() {
      var field = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var a = [];
      if (typeof field === 'string' && field) a.push(field);else if (Array.isArray(field)) a.push.apply(a, (0, _toConsumableArray2.default)(field));
      if (a.length > 0) return this.control.filter(function (item) {
        return a.indexOf(item.code) > -1;
      });else return this.control;
    },
    /**
     * @description: 控制滚动条
     * @return { void }
     */
    onScroll: function onScroll() {
      var el = document.getElementsByClassName('el-dialog__body')[0]; // 记录当前滚动位置
      setTimeout(function () {
        // 等待 DOM 渲染后恢复滚动位置
        document.getElementsByClassName('el-dialog__body')[0].scrollTop = el.scrollHeight;
      }, 0);
    },
    /** 计算栅格控制器
     * @description: 计算栅格控制器
     * @param { Object } item 计算条目
     * @return { Object } 返回栅格控制器
     */
    computedGrid: function computedGrid(item) {
      var _ref, _item$grid;
      var a = (_ref = (_item$grid = item.grid) !== null && _item$grid !== void 0 ? _item$grid : this.grid) !== null && _ref !== void 0 ? _ref : this.parentGrid;
      var grid = {};
      switch ((0, _typeof2.default)(a)) {
        case 'object':
          Object.assign(grid, a);
          break;
        case 'number':
          Object.assign(grid, {
            span: a
          });
          break;
        default:
          break;
      }
      return grid;
    },
    /**
     * @description: 设置 查询条件
     * @param { * } value 设置的默认参数
     * @param { Array | String } field 获取单个或者一组
     * @return { void }
     */
    setValue: function setValue(value) {
      var field = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var a = [];
      if (typeof field === 'string' && field) a.push(field);else if (Array.isArray(field)) a.push.apply(a, (0, _toConsumableArray2.default)(field));
      var b = [];
      if (a.length > 0) b = this.control.filter(function (item) {
        return a.indexOf(item.code) > -1;
      });else b = this.control;
      b.forEach(function (item) {
        item.value = value;
      });
    },
    /** 重置 输入控件
     * @description: 重置 输入控件
     * @return { void }
     */
    resetValue: function resetValue() {
      this.control.forEach(function (item) {
        item.value = '';
      });
    }
  },
  // directives: {}, #指令
  /* 以下 Vue 的生命周期，皆按照顺序执行，注意看执行触发的时间 */
  created: function created() {
    this.init();
  },
  updated: function updated() {
    // this.init()
    // console.log('wl-form-control')
  }
};